import { createContext, useContext } from 'react';
const StudentViewContext = createContext(null);
export function useStudentView() { return useContext(StudentViewContext); }
export default StudentViewContext;
